<template>
  <div class="flex-column">

    <div class="app-container flex-item">
      <el-row style="height: 100%;">
        <el-col :span="24" style="height: 100%;">
          <div class="bg-white" style="height: 50%;">
            <el-card shadow="never" class="body-small">
              <div slot="header" class="clearfix">
                <el-button type="text" style="padding: 0 11px">企业信息</el-button>
              </div>

              <el-form ref="dataForm" :model="temp" label-position="right" label-width="100px">
                <el-col :span="24" style="height: 100%;">
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'企业名称'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'联系电话'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="24" style="height: 100%;">
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'法定代表人'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'详细地址'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="24" style="height: 100%;">
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'中小企业'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="height: 100%;">
                    <el-form-item size="small" :label="'国有企业'" prop="name">
                      <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>

                <el-form-item size="small" :label="' '">
                  <el-button size="mini" type="primary" @click="changeProfile">确认修改</el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
          <!-- <div class="bg-white" style="height: 50%;">
            <el-card shadow="never" class="body-small" >
              <div slot="header" class="clearfix">
                <el-button type="text" style="padding: 0 11px">修改密码</el-button>
              </div>
              <el-form ref="dataForm" :model="temp" label-position="right" label-width="100px">
                <el-form-item size="small" :label="'新密码'" prop="name">
                  <el-input v-model="newpwd" show-password></el-input>
                </el-form-item>
                <el-form-item size="small" :label="' '">
                  <el-button size="mini" type="primary" @click="changePassword">确认修改</el-button>
                </el-form-item>
              </el-form>


            </el-card>
          </div> -->
        </el-col>


      </el-row>

    </div>
  </div>
</template>

<script>
import {
  listToTreeSelect
} from '@/utils'
import * as login from '@/api/login'
import * as users from '@/api/users'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import waves from '@/directive/waves' // 水波纹指令
import {
  mapGetters
} from 'vuex'
import store from '@/store'

export default {
  name: 'profile',
  components: {},
  directives: {
    waves
  },
  data() {
    return {
      orgTreeProps: { // tree配置项
        children: 'children',
        label: 'label'
      },
      listLoading: true,
      orgs: [], // 用户可访问到的组织列表
      orgsTree: [], // 用户可访问到的所有机构组成的树

      modules: [],
      modulesTree: [], // 用户可访问的所有模块组成的树

      temp: {
        account: '',
        name: '',
        sex: 0
      },
      newpwd: '',
      FormData: {
        busiCertList: [
          {
            id: "string",
            authFrom: "string",
            certCode: "string",
            certName: "string",
            certType: "string",
            conScope: "string",
            content: "string",
            valDate: "string",
            isChangQi: "2",
            authDate: "string"
          }
        ],
        businessDoc: {
          acctName: "string",
          idCard: "string",
          actBalance: 0,
          postCode: "string",
          regCapital: "string",
          businessCont: "string",
          address: "string",
          cusNatId: "string",
          legalRep: "string",
          isAbandon: "1",
          logogram: "string",
          yingyzz: "string",
          lat: "string",
          content: "string",
          businessCode: "string",
          isBusiness: "2",
          lastCareTime: "string",
          isPartner: "2",
          operMode: "string",
          zoneId: "string",
          taxNo: "string",
          docLevId: 0,
          rfEntId: "string",
          regNo: "string",
          reason: "string",
          lastRtnTime: "string",
          regAuthority: "string",
          oldCode: "string",
          powerBalance: 0,
          directorId: "string",
          is_Supp: "1",
          regDates: "string",
          rptYear: 0,
          regValDate: "string",
          telephone: "string",
          routeOrder: 0,
          subbranch: "string",
          pBusinessId: "string",
          gpsAdd: "string",
          contact: "string",
          isPass: "1",
          ing: "string",
          url: "string",
          businessName: "string",
          orgCert: "string",
          orgCertVal: "string",
          routeId: 0,
          shortName: "string",
          isMfc: "1",
          lastDate: "string",
          isLogistics: "2",
          capacity: "string",
          cusSubId: "string",
          koul: 0,
          bankAccount: "string",
          selAttachId: "string",
          groupId: "string",
          qaDirName: "string",
          email: "string",
          regYearDate: "string",
          fax: "string",
          chanceId: "string",
          orgCertDate: "string",
          infoState: "1",
          isClients: "2",
          isFreeze: "2",
          id: "string",
          formId: "string",
          schemeId: "string"
        },
        supplyDoc: {
          isAbandon: "1",
          xukzh: "string",
          suppLev: 0,
          fkzc: "string",
          gysgysbh: "string",
          saleManId: "string",
          lsxinded: 0,
          oldgysbh: "string",
          archNo: "string",
          lsxindhfts: "string",
          isFirst: "1",
          xinded: 0,
          supCtrlType: 0,
          jsfs: "string",
          isProcur: "1",
          dftAddress: "string",
          isgmp: "2",
          expAutOrg: "string",
          duikm: "string",
          songhts: 0,
          apid: "string",
          lsxindts: 0,
          resAutOrg: "string",
          suppCate: 0,
          gysbh: "string",
          suppType: "string",
          xindts: 0,
          docLevId: 0,
          elecCode: "string",
          jypzhs: 0,
          id: "string",
          formId: "string",
          schemeId: "string"
        }
      }




    }
  },
  computed: {
    ...mapGetters(['defaultorgid', 'name'])
  },
  filters: {

  },
  mounted() {
    this.getUserProfile()
    this.getOrgTree()
    this.getModulesTree()
  },
  methods: {
    changeProfile() {
      const _this = this

      users.saveDoce(this.FormData).then(response => {
        _this.$message({
          message: response.message,
          type: 'success'
        })
      })
    },

    changePassword() {
      const _this = this
      users.changePassword({
        account: _this.temp.account,
        password: _this.newpwd
      }).then(response => {
        _this.$message({
          message: response.message,
          type: 'success'
        })
      })
    },

    handleNodeClick(data) {
      store.commit('SET_DEFAULTORG', data)
      this.getOrgTree()
    },

    getUserProfile() {
      var _this = this // 记录vuecomponent
      login.getUserProfile().then(response => {
        _this.temp = response.result
      })
    },

    getModulesTree() {
      var _this = this // 记录vuecomponent
      login.getModules().then(response => {
        _this.modules = response.result.map(function (item) {
          return {
            id: item.id,
            label: item.name,
            parentId: item.parentId
          }
        })
        var tmp = JSON.parse(JSON.stringify(_this.modules))
        _this.modulesTree = listToTreeSelect(tmp)
      })
    },

    getOrgTree() {
      var _this = this // 记录vuecomponent
      login.getOrgs().then(response => {
        _this.orgs = response.result.map(function (item) {
          var name = item.name
          if (_this.defaultorgid === item.id) {
            name = name + '✅'
          }
          return {
            id: item.id,
            label: name,
            parentId: item.parentId
          }
        })
        var orgstmp = JSON.parse(JSON.stringify(_this.orgs))
        _this.orgsTree = listToTreeSelect(orgstmp)
      })
    }
  }
}

</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.el-select.filter-item.el-select--small {
  width: 100%;
}
</style>
